<template>
    <div class="container">
        <loader :active="loading" />

        <header class="jumbotron">
            <div class="info">
                <div class="info-head"><font-awesome-icon icon="fighter-jet" />
                    <h3>Ustawienia teleportu</h3></div>
                    <small>Poniżej możesz ustawić kanał, na który ma przenosić teleport.</small><br>
                    <small>Jeśli chcesz by jakieś osoby były przenoszone na inny kanał niż domyślny, stwórz nową regułę.</small>
            </div>

            <refresh :func="refresh"/>
        </header>

        <div class="row">
            <div class="col-md-4">
                <div class="card">
                    <form name="form" @submit.prevent="changeDefaultChannel">
                        <div class="card-header">
                            <h5> Kanał domyślny </h5>
                        </div>

                        <div class="card-body text-center">
                            <div v-if="Object.keys(all).length">
                                <strong>Obecnie wybrany kanał</strong>
                                <ul class="ts-channel">
                                    <channel :channel="all.channel" :clickable="false"/>
                                </ul>
                            </div>
                            <div v-else>
                                <h6>Brak ustawionego kanału domyślnego</h6>
                            </div>
                        </div>

                        <div class="card-footer">
                            <button class="btn btn-info" :disabled="loading">
                                <span><font-awesome-icon icon="edit"/> Zmień</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-md-8">
                <div class="card">
                    <form name="form" @submit.prevent="addRule">
                        <div class="card-header">
                            <h5> Reguły </h5>
                        </div>

                        <div class="card-body text-center">
                            <v-client-table :data="rules" :columns="columns" :options="options">
                                <div slot="options" slot-scope="props"><button class="btn btn-danger" @click.prevent="delRule(props.row.client.dbid)">Usuń</button></div>
                                <ul class="ts-channel" slot="channel" slot-scope="props">
                                    <channel :channel="props.row.channel" :clickable="false"/>
                                </ul>
                                <client slot="client" slot-scope="props" :client="props.row.client"/>
                            </v-client-table>
                        </div>

                        <div class="card-footer">
                            <button class="btn btn-success" :disabled="loading">
                                <span><font-awesome-icon icon="plus"/> Dodaj nową regułę</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TeleportService from '../services/teleport.service';
    import Vue from "vue";
    import SelectOnline from "../components/SelectOnline";
    import SelectChannels from "../components/SelectChannels";

    export default {
        name: 'Teleport',
        data() {
            return {
                loading: true,
                all: {},
                rules: [],
                columns: ['client', 'channel', 'options'],
                options: {
                    headings: {
                        client: 'Klient',
                        channel: 'Kanał',
                        options: 'Opcje',
                    },
                    filterable: ['client', 'channel'],
                    sortable: [],
                    texts: window.vueTableLocalize,
                },
            };
        },
        mounted() {
            this.refresh();
        },
        methods: {
            refresh() {
                this.loading = true;

                TeleportService.getSettings().then(
                    response => {
                        this.all = response.data.all;
                        this.rules = response.data.rules;
                        this.loading = false;
                    },
                    error => {
                        this.loading = false;
                        console.log(error)
                    }
                );
            },
            changeDefaultChannel() {
                this.loading = true;

                TeleportService.getAllChannels().then(
                    async (response) => {
                        let channels = response.data.allChannels;
                        let ComponentClass = Vue.extend(SelectChannels);
                        let vueFormInstance = new ComponentClass({
                            propsData: {channels: channels, onlyOne: true, allChecked: false}
                        });

                        let { value } = await Vue.swal.fire({
                            title: 'Wybierz kanał',
                            html: '<div id="channels"></div>',
                            showCancelButton: true,
                            confirmButtonText: 'Ok',
                            cancelButtonText: 'Anuluj',
                            showLoaderOnConfirm: true,
                            onBeforeOpen: () => {
                                vueFormInstance.$mount();
                                document.getElementById("channels").appendChild(vueFormInstance.$el);
                            },
                            preConfirm: () => {
                                let result =  vueFormInstance.getResults();
                                vueFormInstance.$destroy();
                                vueFormInstance = null;
                                return result;
                            }
                        });

                        if (value) {
                            let cid = value;
                            TeleportService.changeDefaultChannel(cid).then(
                                () => {
                                    this.loading = true;
                                    this.refresh();

                                    Vue.swal.fire({
                                        title: 'Zmieniono kanał domyślny!',
                                        icon: 'success',
                                        timer: 1000,
                                        showConfirmButton: false,
                                    });
                                },
                                error => {
                                    this.loading = false;
                                    console.log(error);
                                }
                            );
                        } else
                            this.loading = false;
                    },
                    error => {
                        this.loading = false;
                        console.log(error)
                    }
                );
            },
            async addRule() {
                this.loading = true;

                TeleportService.getAllClients().then(
                    async (response) => {
                        let clients = response.data.allClients;
                        let ComponentClass = Vue.extend(SelectOnline);
                        let currentClients = await this.rules.map(function(value) {
                            return value.client;
                        });

                        let vueFormInstance = new ComponentClass({
                            propsData: {clients: clients, onlyOne: false, allChecked: false, idType: "dbid", omitted: currentClients}
                        });

                        let { value } = await Vue.swal.fire({
                            title: '1. Wybierz użytkowników',
                            html: '<div id="clients"></div>',
                            showCancelButton: true,
                            confirmButtonText: 'Ok',
                            cancelButtonText: 'Anuluj',
                            showLoaderOnConfirm: true,
                            onBeforeOpen: () => {
                                vueFormInstance.$mount();
                                document.getElementById("clients").appendChild(vueFormInstance.$el);
                            },
                            preConfirm: () => {
                                let result =  vueFormInstance.getResults();
                                vueFormInstance.$destroy();
                                vueFormInstance = null;
                                return result;
                            }
                        });

                        if (value) {
                            let dbids = value;
                            TeleportService.getAllChannels().then(
                                async (response) => {
                                    let channels = response.data.allChannels;
                                    let ComponentClass = Vue.extend(SelectChannels);
                                    let vueFormInstance = new ComponentClass({
                                        propsData: {channels: channels, onlyOne: true, allChecked: false}
                                    });

                                    let { value } = await Vue.swal.fire({
                                        title: '2. Wybierz kanał',
                                        html: '<div id="channels"></div>',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ok',
                                        cancelButtonText: 'Anuluj',
                                        showLoaderOnConfirm: true,
                                        onBeforeOpen: () => {
                                            vueFormInstance.$mount();
                                            document.getElementById("channels").appendChild(vueFormInstance.$el);
                                        },
                                        preConfirm: () => {
                                            let result =  vueFormInstance.getResults();
                                            vueFormInstance.$destroy();
                                            vueFormInstance = null;
                                            return result;
                                        }
                                    });

                                    if (value) {
                                        let cid = value;
                                        TeleportService.addRule(dbids, cid).then(
                                            () => {
                                                this.loading = true;
                                                this.refresh();

                                                Vue.swal.fire({
                                                    title: 'Dodano nową regułę pomyślnie!',
                                                    icon: 'success',
                                                    timer: 1000,
                                                    showConfirmButton: false,
                                                });
                                            },
                                            error => {
                                                this.loading = false;
                                                console.log(error);
                                            }
                                        );
                                    } else
                                        this.loading = false;
                                },
                                error => {
                                    this.loading = false;
                                    console.log(error)
                                }
                            );
                        } else
                            this.loading = false;
                    },
                    error => {
                        this.loading = false;
                        console.log(error)
                    }
                );
            },
            delRule(dbid) {
                Vue.swal.fire({
                    title: 'Jesteś pewny?',
                    text: "Nie będziesz mógł cofnąć tej operacji!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Tak, usuń!',
                    cancelButtonText: 'Anuluj'
                }).then((result) => {
                    if (result.value) {
                        this.loading = true;

                        TeleportService.delRule(dbid).then(
                            () => {
                                this.refresh();

                                Vue.swal.fire({
                                    title: 'Usunięto regułę!',
                                    icon: 'success',
                                    timer: 1000,
                                    showConfirmButton: false,
                                });
                            },
                            error => {
                                this.loading = false;
                                console.log(error)
                            }
                        );
                    }
                });
            }
        }
    };
</script>

<style>
    .ts-channel {
        list-style: none;
        padding-inline-start: 0px;
    }
</style>
